export const DEFAULT_WORKSPACE_CURRENCY = "USD";
